import React from 'react';
import './GuestsMarsComplete.css'; // Import a custom CSS file for styling
import useFormContext from "./useFormMarsComplete.js"

const GuestsMarsComplete = () => {
  const { guestDetails } = useFormContext()

  return (
    <div className="main-container col-md-10">
      <div className="overview-section">
        <div className="overview">
          <span>OVERVIEW</span>
          <div className="status adminOverviewSpacing">
            <div className="status-item">
              <span className="under-review">UNDER REVIEW</span>
              <span id="UnderReviewCount" className="count">{guestDetails.UnderReview}</span>
            </div>
            <div className="status-item">
              <span className="Confirmed">CONFIRMED</span>
              <span id="ConfirmedCount" className="count">{guestDetails.Confirmed}</span>
            </div>
          </div>
        </div>
      </div>
      <div className="content">
        <div className="family-guests">
          <div className="family-header">
            <span>MARS FAMILY GUESTS</span>
          </div>

          <span className="seat-request-title">NUMBER OF SEATS REQUESTED</span>
          <span id="SeatsRequiredCount" className="seat-request-count">{guestDetails.SeatsRequired}</span>

          <div className="guest-list" id="guestItem">
            {guestDetails.guests.map((guest, index) => (
              <div className="guest-item" key={index}>
                <div className="guest-name">{guest.name}</div>
                <div className="guest-status">
                  <span id={guest.name + 'status'} className={`card-footer-button btn rounded-pill ${guest.status}`}>
                    {guest.status}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div style={{ height: "100px" }}></div>
    </div>
  );
};

export default GuestsMarsComplete;